module.exports = __webpack_public_path__ + "img/skull_6_bj.8945172a.png";